import type { GridInitialState } from "@mui/x-data-grid-premium"
import type { PlotlyDataLayoutConfig } from "plotly.js-dist-min"
import { DataStatus } from "helpers/data-statuses"

export const ARTIFACT_KINDS = {
  PLOT: "plot",
  TABLE: "table",
} as const

export type ArtifactKind = typeof ARTIFACT_KINDS[keyof typeof ARTIFACT_KINDS]

export interface PositionSet {
  id: string
  type: string
}

export interface AgentArguments {
  modelId?: string
  positionSet?: PositionSet
  base?: PositionSet
  startDate?: string
  endDate?: string
  accountAlias?: string
  [key: string]: unknown
}

export interface ArtifactColumn {
  label: string
  format: string
  id?: string
  key?: string
  field?: string
  name?: string
  isPerShare?: boolean
}

export interface TableArtifact {
  id: string
  type: "table"
  records: Record<string, unknown>[]
  columns: ArtifactColumn[]
  explainSteps?: string
}

export interface PlotArtifact {
  id: string
  type: "plot"
  figure: PlotlyDataLayoutConfig & Record<string, unknown>
  tableArtifactId?: string
}

export type Artifact = TableArtifact | PlotArtifact

export interface RunWorkflowResponse {
  artifacts: Artifact[]
  executedAt: string
  warnings: string[]
}

export interface ArtifactTemplateProps {
  artifact: Artifact
  currency?: string
  dataGridState?: GridInitialState
  onDataGridStateChange?: (state: GridInitialState) => void
}

export interface ArtifactRendererProps {
  status: DataStatus
  data: Artifact | null
  title?: string
  isPinning?: boolean
  onRetry?: () => void
  [key: string]: unknown
}
